import { render, staticRenderFns } from "./payMethodsList.vue?vue&type=template&id=10c4943e&scoped=true&"
import script from "./payMethodsList.vue?vue&type=script&lang=js&"
export * from "./payMethodsList.vue?vue&type=script&lang=js&"
import style0 from "./payMethodsList.vue?vue&type=style&index=0&id=10c4943e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c4943e",
  null
  
)

export default component.exports